var storefrontApp = angular.module('storefrontApp');
storefrontApp.service('digitizingService', ['$http', function ($http) {
    return {
        addDigitizingItemToCart: function (cdrowId) {
            return $http.post("storefrontapi/cart/addcditemtocart?cdRowId=" + cdrowId);
        },
        getCDContent: function () {
            return $http.get('storefrontapi/customdigitizing/cdcontent');
        },
        getQuoteRequestPageContent: function () {
            return $http.get('storefrontapi/customdigitizing/requestformcontent');
        },
        getCDRows: function (pg, ft) {
            if (!pg)
                pg = "1";
            if (ft)
                return $http.get('storefrontapi/customdigitizing/getcdrows?pageNumber=' + pg + '&filterType=' + ft);
            else
                return $http.get('storefrontapi/customdigitizing/getcdrows?pageNumber=' + pg);
        },
        getCDMailbox: function (cdRowId) {
            return $http.get('storefrontapi/customdigitizing/getcdmailbox?cdRowId=' + cdRowId);
        },
        cdMailboxOperations: function (cDMailboxOperation) {
            return $http({
                method: 'POST',
                url: "storefrontapi/customdigitizing/cdmailboxoperations",
                data: cDMailboxOperation,
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        },
        postCDRequestForm: function (cDNewRequestForm) {
            return $http({
                method: 'POST',
                url: "storefrontapi/customdigitizing/submitcdform",
                data: cDNewRequestForm,
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        },
        getCDRowDetails: function (cdRow) {
            return $http.get('storefrontapi/customdigitizing/getcdrowdetails?cdRow=' + cdRow);
        },
        getSampleImages: function () {
            return $http.get('storefrontapi/customdigitizing/getcustomdigitizingsampleimages');
        },
        getTestimonials: function () {
            return $http.get('storefrontapi/getapprovedreviewsbyproductdefinition?productDefinition=customdigitizing&rating=5&maxresults=10');
        },
        convertQuoteToOrder: function (cdRowId, turnaround, taChange) {
            return $http.get('storefrontapi/customdigitizing/convertquote?cdRowId=' + cdRowId + '&turnaround=' + turnaround + '&turnAroundChange=' + taChange)
        },
        getCustomerCDOrderHistory: function () {
            return $http.get('storefrontapi/customdigitizing/getcustomercdorderhistory');
            }
        };
    },
]);
